export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20digital%20illustration%20with%20warm%20red%20and%20deep%20crimson%20gradient%20background%2C%20featuring%20artistic%20geometric%20patterns%20and%20flowing%20data%20stream%20lines%20in%20golden%20amber%20tones%2C%20modern%20news%20media%20aesthetic%2C%20dynamic%20energy%2C%20editorial%20design%20style%2C%20dark%20rich%20atmosphere%20with%20vibrant%20accent%20light%20streaks%2C%20no%20text&width=1800&height=1200&seq=hero-bg-51bl&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-200 text-xs md:text-sm font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              实时爆料 · 全网追踪
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              51爆料
              <span className="block text-accent-300 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-1">
                全网吃瓜第一站
              </span>
            </h1>

            <p className="text-lg md:text-xl text-accent-200/90 font-medium mb-6">
              娱乐圈八卦 · 社会热点 · 全网吃瓜，尽在51爆料
            </p>

            <p className="text-sm md:text-base text-background-50/75 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51爆料吃瓜网每日追踪娱乐圈猛料、网红翻车、社会热点事件，聚合全网最新最热的吃瓜内容。
              覆盖微博、抖音、小红书等100+平台，一分钟刷遍全网的瓜。无论是明星塌房、综艺名场面
              还是热门话题深度解读，你关心的爆料都在这里。实时更新，不吃冷瓜，只爆新鲜料。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">
                  200+
                </div>
                <div className="text-xs md:text-sm text-background-50/65 mt-1">
                  日均更新爆料
                </div>
              </div>
              <div className="w-px h-10 bg-background-50/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">
                  100+
                </div>
                <div className="text-xs md:text-sm text-background-50/65 mt-1">
                  覆盖平台
                </div>
              </div>
              <div className="w-px h-10 bg-background-50/15 hidden sm:block"></div>
              <div className="text-center hidden sm:block">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">
                  7×24h
                </div>
                <div className="text-xs md:text-sm text-background-50/65 mt-1">
                  实时追踪
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm md:text-base transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即围观热搜
              </a>
              <a
                href="#contact"
                onClick={(e) => handleScrollTo(e, '#contact')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/25 font-medium rounded-full text-sm md:text-base transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-send-plane-line"></i>
                我要爆料投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20a%20modern%20digital%20newsroom%20with%20floating%20glowing%20headline%20cards%20in%20warm%20coral%20and%20amber%20hues%2C%20artistic%20magazine%20collage%20style%2C%20clean%20modern%20composition%2C%20dark%20rich%20background%20with%20soft%20light%20accents%2C%20creative%20editorial%20design%20aesthetic%2C%20no%20text%20no%20letters&width=800&height=600&seq=hero-visual-51bl&orientation=landscape"
                alt="51爆料 - 全网吃瓜热点聚合"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-600/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}